import createAxios from 'config/axios'

const URL = '/registrar/v1/customers/accounts'
const getCustomerAccounts = () => createAxios.get(URL)

export default getCustomerAccounts
